if (!customElements.get('inline-video-player')) {
  const PLAYING_CLASS = 'is-playing';

  customElements.define(
    'inline-video-player',
    class InlineVideoPlayer extends HTMLElement {
      constructor() {
        super();

        this.video = this.querySelector('video');
        this.posterMobile = this.video.getAttribute('data-poster-mobile');
        this.posterDesktop = this.video.getAttribute('data-poster-desktop');
        this.videoMobile = this.video.getAttribute('data-src-mobile');
        this.videoDesktop = this.video.getAttribute('data-src-desktop');
        this.playButton = this.querySelector('.inline-video-player__button');
        this.overlay = this.querySelector('.inline-video-player__overlay');
        this.isOverlayClickable = this.classList.contains('inline-video-player--clickable');
      }

      connectedCallback() {
        this.handleVideoStatus();
        this.handleMediaChange();
        this.handleButtonClick();

        if (this.isOverlayClickable) {
          this.handleClickableOverlay();
        }
      }

      handleVideoStatus() {
        this.updateVideoStatus();

        this.video.addEventListener('playing', () => this.updateVideoStatus());
        this.video.addEventListener('pause', () => this.updateVideoStatus());
        this.video.addEventListener('ended', () => this.updateVideoStatus());
      }

      updateVideoStatus() {
        if (!this.video.paused) {
          this.classList.add(PLAYING_CLASS);
          this.playButton.setAttribute('aria-label', 'Pause');
        } else {
          this.classList.remove(PLAYING_CLASS);
          this.playButton.setAttribute('aria-label', 'Play');
        }
      }

      handleMediaChange() {
        const mql = window.matchMedia('(min-width: 768px)');

        this.updateVideoSrc(!mql.matches);
        mql.addEventListener('change', (e) => this.updateVideoSrc(!e.matches));
      }

      updateVideoSrc(isMobile = false) {
        if (isMobile) {
          this.video.setAttribute('src', this.videoMobile);
          this.video.setAttribute('poster', this.posterMobile);
        } else {
          this.video.setAttribute('src', this.videoDesktop);
          this.video.setAttribute('poster', this.posterDesktop);
        }

        if (this.video.hasAttribute('data-autoplay')) {
          this.video.play();
        }
      }

      togglePlayPause() {
        if (this.video.paused) {
          this.video.play();
          this.classList.remove('is-hovered')

          if (this.isOverlayClickable) {
            this.overlay.focus();
          }
        } else {
          this.video.pause();
        }
      }

      handleButtonClick() {
        this.playButton.addEventListener('click', this.togglePlayPause.bind(this));
      }

      handleClickableOverlay() {
        this.overlay.setAttribute('tabindex', '-1');
        this.overlay.addEventListener('click', this.togglePlayPause.bind(this));
        this.overlay.addEventListener('keydown', (event) => {
          if (event.keyCode === 13 || event.keyCode === 32) {
            event.preventDefault();
            this.togglePlayPause();
          }
        });

        this.addEventListener('mouseenter', () => this.classList.add('is-hovered'))
        this.addEventListener('mouseout', () => this.classList.remove('is-hovered'))
      }
    }
  );
}